import { GenericObject } from '@synergy/models';

import { User } from './user';

/**
 * A remark someone wrote on a document (#2156). It has its own table, so it can
 * be edited and taken back without touching the activity log.
 */
export class DocumentComment {
    public id!: number;
    public text!: string;
    public createdBy?: User;
    public createdAt!: string;
    public updatedAt!: string;
    /** Only the author may change what they wrote — decided by the backend. */
    public editable = false;

    public static fromPlainObject(object: GenericObject): DocumentComment {
        const comment = new DocumentComment();

        comment.id = object['id'];
        comment.text = object['text'];
        comment.createdAt = object['createdAt'];
        comment.updatedAt = object['updatedAt'];
        comment.editable = !!object['editable'];

        if (object['createdBy']) {
            comment.createdBy = User.fromPlainObject(object['createdBy']);
        }

        return comment;
    }
}
